import styled from '@emotion/styled'
import { FC, PropsWithChildren } from 'react'

export interface InformationProps {}

export const Information: FC<PropsWithChildren<InformationProps>> = ({
  children
}) => {
  return <Base>{children}</Base>
}

const Base = styled('div')`
  display: flex;
  flex-direction: column;

  // Hide last divider inside of Information component
  & > .ant-divider:last-child {
    display: none;
  }
`
